const contentful = require('contentful')

const client = contentful.createClient({
  space: 'fgegtiq0krok',
  environment: 'master', // defaults to 'master' if not set
  accessToken: '_xMeujHZb1QFWzM6wkErpQhvon5eCNgSpyafJUnUU74'
})

export default client;